import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, Trash2 } from "lucide-react";
import api from "@/lib/api";

const PLANS = ["free", "starter", "pro", "unlimited"];

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");

  const load = async () => { const { data } = await api.get(`/admin/users${q ? `?q=${encodeURIComponent(q)}` : ""}`); setUsers(data); };
  useEffect(() => { load(); }, []);

  const update = async (id, body) => { await api.put(`/admin/users/${id}`, body); toast.success("Updated"); load(); };
  const del = async (id) => { if (!confirm("Delete this user?")) return; await api.delete(`/admin/users/${id}`); toast.success("Deleted"); load(); };

  return (
    <div className="px-5 lg:px-10 py-8 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Users</h1>
      <div className="mt-5 flex gap-2">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-3 top-2.5 w-4 h-4 text-brand-muted" />
          <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search name or email" className="w-full pl-9 pr-3 py-2 rounded-xl border border-brand-borderc focus:border-brand-purple outline-none" />
        </div>
        <button onClick={load} className="px-4 py-2 rounded-full bg-brand-navy text-white text-sm font-semibold">Search</button>
      </div>

      <div className="mt-5 bg-white rounded-2xl border border-brand-borderc overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-brand-surface text-brand-navy">
            <tr className="text-left">
              <th className="px-4 py-3">User</th>
              <th className="px-4 py-3">Plan</th>
              <th className="px-4 py-3">Usage</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Role</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-brand-borderc">
            {users.map((u) => (
              <tr key={u.id}>
                <td className="px-4 py-3">
                  <div className="font-semibold text-brand-navy">{u.name}</div>
                  <div className="text-xs text-brand-muted">{u.email}</div>
                </td>
                <td className="px-4 py-3">
                  <select defaultValue={u.plan} onChange={(e) => update(u.id, { plan: e.target.value })} className="px-2 py-1 rounded-lg border border-brand-borderc text-xs">
                    {PLANS.map((p) => <option key={p}>{p}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-xs text-brand-muted">{u.words_used?.toLocaleString() || 0} words</td>
                <td className="px-4 py-3">
                  <button onClick={() => update(u.id, { is_active: !u.is_active })} className={`text-xs px-2 py-1 rounded-full ${u.is_active ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-600"}`}>
                    {u.is_active ? "Active" : "Inactive"}
                  </button>
                </td>
                <td className="px-4 py-3">
                  <select defaultValue={u.role || "user"} onChange={(e) => update(u.id, { role: e.target.value })} className="px-2 py-1 rounded-lg border border-brand-borderc text-xs">
                    <option>user</option><option>admin</option>
                  </select>
                </td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => del(u.id)} className="p-1.5 text-red-500 hover:bg-red-50 rounded-lg"><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
